import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Icon from '../assets/icon.svg';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const token = localStorage.getItem('token');
    return !!token;
  });
  const [activeSection, setActiveSection] = useState('home');
  const [scrollY, setScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
      
      // Active section detection
      const sections = ['home', 'legal-documents', 'url-shortener', 'customer-support', 'internal-ads', 'pricing', 'docs'];
      const currentSection = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      
      if (currentSection) {
        setActiveSection(currentSection);
      } else if (window.scrollY < 100) {
        setActiveSection('home');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  const handleSectionClick = (sectionId) => {
    if (location.pathname === '/') {
      // Ana sayfadaysak direkt scroll yap
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Başka sayfadaysak ana sayfaya git ve sonra scroll yap
      navigate(`/#${sectionId}`);
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`fixed top-3 left-1/2 transform -translate-x-1/2 z-50 bg-black/20 backdrop-blur-md rounded-2xl shadow-2xl px-6 transition-all duration-300 ${
      scrollY > 50 ? 'scale-95' : 'scale-100'
    }`}>
      <div className="py-2">
        <div className="flex items-center justify-between h-12">
          {/* Logo */}
          <a href="#" onClick={handleLogoClick} className="flex items-center">
            <img src={Icon} alt="AppActs Logo" className="h-6 w-6 mr-2" />
            <span className={`text-white text-base mr-8 transition-all duration-200 ${
              activeSection === 'home' ? 'font-bold' : 'font-light'
            }`}>AppActs.com</span>
          </a>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-4">
            <button onClick={() => handleSectionClick('legal-documents')} className={`transition-colors duration-200 whitespace-nowrap text-sm ${
              activeSection === 'legal-documents' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
            }`}>Legal Documents</button>
            <button onClick={() => handleSectionClick('url-shortener')} className={`transition-colors duration-200 whitespace-nowrap text-sm ${
              activeSection === 'url-shortener' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
            }`}>URL Shortener</button>
            <button onClick={() => handleSectionClick('customer-support')} className={`transition-colors duration-200 whitespace-nowrap text-sm ${
              activeSection === 'customer-support' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
            }`}>Support</button>
            <button onClick={() => handleSectionClick('internal-ads')} className={`transition-colors duration-200 whitespace-nowrap text-sm ${
              activeSection === 'internal-ads' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
            }`}>Internal Ads</button>
            <button onClick={() => handleSectionClick('pricing')} className={`transition-colors duration-200 whitespace-nowrap text-sm ${
              activeSection === 'pricing' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
            }`}>Pricing</button>
            <button onClick={() => handleSectionClick('docs')} className={`transition-colors duration-200 whitespace-nowrap text-sm ${
              activeSection === 'docs' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
            }`}>Docs</button>
          </nav>
          
          {/* Desktop Register/Dashboard Button */}
          <div className="hidden md:flex items-center space-x-4 ml-6">
            <Link
              to={isLoggedIn ? "/dashboard" : "/register"}
              className="inline-flex items-center px-3 py-1.5 bg-white text-black rounded-lg hover:bg-white/90 transition-colors duration-200 font-medium text-sm"
            >
              {isLoggedIn ? "Dashboard" : "Register"}
            </Link>
          </div>

          {/* Mobile Hamburger Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden flex items-center justify-center w-8 h-8 text-white hover:text-white/80 transition-colors duration-200"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-white/10 pt-4">
            <nav className="flex flex-col space-y-3">
              <button onClick={() => handleSectionClick('legal-documents')} className={`transition-colors duration-200 text-sm text-left ${
                activeSection === 'legal-documents' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
              }`}>Legal Documents</button>
              <button onClick={() => handleSectionClick('url-shortener')} className={`transition-colors duration-200 text-sm text-left ${
                activeSection === 'url-shortener' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
              }`}>URL Shortener</button>
              <button onClick={() => handleSectionClick('customer-support')} className={`transition-colors duration-200 text-sm text-left ${
                activeSection === 'customer-support' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
              }`}>Support</button>
              <button onClick={() => handleSectionClick('internal-ads')} className={`transition-colors duration-200 text-sm text-left ${
                activeSection === 'internal-ads' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
              }`}>Internal Ads</button>
              <button onClick={() => handleSectionClick('pricing')} className={`transition-colors duration-200 text-sm text-left ${
                activeSection === 'pricing' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
              }`}>Pricing</button>
              <button onClick={() => handleSectionClick('docs')} className={`transition-colors duration-200 text-sm text-left ${
                activeSection === 'docs' ? 'text-white font-bold' : 'text-white/80 hover:text-white'
              }`}>Docs</button>
              <div className="pt-3 border-t border-white/10">
                <Link
                  to={isLoggedIn ? "/dashboard" : "/register"}
                  className="inline-flex items-center justify-center w-full px-4 py-2 bg-white text-black rounded-lg hover:bg-white/90 transition-colors duration-200 font-medium text-sm"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {isLoggedIn ? "Dashboard" : "Register"}
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;